import React from "react";
import { Plane } from "lucide-react";

/** Ligne de vol décorative : trainée dorée en pointillés + petit avion qui traverse lentement. */
export const FlightTrail = ({ className = "", tone = "gold" }) => (
  <div aria-hidden="true" data-testid="flight-trail" className={`pointer-events-none relative h-12 w-full overflow-hidden ${className}`}>
    <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1200 48" preserveAspectRatio="none">
      <path
        d="M0 36 C 320 6, 880 6, 1200 36"
        fill="none"
        stroke={tone === "gold" ? "#C5A059" : "#ffffff"}
        strokeOpacity="0.32"
        strokeWidth="1.4"
        strokeDasharray="5 11"
        className="animate-dash"
      />
    </svg>
    <div className="absolute top-1.5 left-0 animate-fly">
      <Plane size={15} className={`-rotate-[18deg] ${tone === "gold" ? "text-gold/80" : "text-white/70"}`} />
    </div>
  </div>
);
